import { from } from 'rxjs';
import { Console } from 'console';
import Popup from 'devextreme/ui/popup';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import DataGrid from "devextreme/ui/data_grid";
import { ToastService } from 'ng-uikit-pro-standard';
import CustomStore from 'devextreme/data/custom_store';
import { DxDataGridComponent } from 'devextreme-angular';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { TaskService } from 'src/app/services/task.service';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { GeneralService } from 'src/app/services/general.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { CreateUpdateTaskComponent } from '../create-update-task/create-update-task.component';
import { DxDropDownBoxModule, DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { Component, OnInit, SimpleChanges, ViewContainerRef, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild('GridTasks', { static: false }) TasksGrid: DxDataGridComponent;
  @ViewChild('SummaryTaskGrid', { static: false }) SummaryTaskGrid: DxDataGridComponent;
  @ViewChild('memorizeGrid', { static: false }) MemorizeTasksGrid: DxDataGridComponent;

  @Input() parentProjectId: number;
  @Input() offsetHeight: any = 0;
  @Input() expandpopup: boolean; 
  @Output() onOpenFullScreen = new EventEmitter<any>();;

  cancelButtonSummary: any;
  saveButtonSummary: any;

  customer: any;
  now = new Date();
  tooltip: any;
  popupTask = false;
  popupSummaryTask = false;
  popupDeleteSummaryTask = false;
  popupGridSummaryTask = false;
  popupImportMemorizedTask = false;
  serviceresourcesText = '';
  selectedRows = false;
  private _project: any;
  expandAll: any;

  dateFormat = '';

  @Input('project')
  set project(project: any) {
    this._project = project;
  }

  get project(): any { return this._project; }

  filterPagedTask = {
    pageindex: 1,
    pagesize: 20,
    orderid: 1,
    summarytaskid: 0,
    projectnumber: '',
    taskname: '',
    responsiblesids: '',
    statusids: '',
    categoryids: '',
    duedate: '',
    taskid: 0,
    projectname: '',
    resourceids: '',
    priorityids: '',
    phaseids: '',
    projectid: 0
  };
  salesCategorySelect: any = [];
  categorySelect: any = [];
  statusSelect: any = [];
  prioritySelect: any = [];
  employeeSelect: any = [];
  phasesSelect: any = [];
  projectlist: any;
  updateProjectInfoName: any;
  projectslist: any;

  taskDataSource: any = [];

  taskresourcesText: string;
  taskresourcesValues = [];

  taskstatusValues = [];
  taskstatusText: string;

  //Task
  selectedTaskId: any;
  showpopupDeleteTask: boolean = false;
  showpopupDuplicateTask: boolean = false;
  filterValue: Array<any>;

  categoriesValues = [];
  categoriesText: string;

  responsibleText: string;
  taskresponsiblesValues = [];

  resourcesValues = [];
  resourcesText: string;

  public _formEntity: FormGroup;
  _formSummary: FormGroup = new FormGroup({
    id: new FormControl({ value: 0, disabled: false }, []),
    name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    projectid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
    startdate: new FormControl({ value: null, disabled: false }, []),
    duedate: new FormControl({ value: null, disabled: false }, []),
    completionperc: new FormControl({ value: 0, disabled: false }, []),
    notes: new FormControl({ value: '', disabled: false }, []),
  });
  summaryTask = [];
  loading = false;
  summaryToDeleteId = null;

  dsPagedTask: any;
  percent = 0;
  _formNewTask: FormGroup;
  locationSelect: any;

  projectInfoModel = {
    projectid: 0,
    projectname: '',
    projectnumber: ''
  };


  items = [
    {
      id: 1,
      name: 'Summary Task',
    },
    {
      id: 2,
      name: 'Task',
    },
    {
      id: 3,
      name: 'Import from Memorized Task',
    }
  ];

  taskFilters: any = {};
  rowSelected: any;

  //Multiple   Edit Tasks
  rowSelectedTask: any;
  popupEditTask: any;

  employees: any;
  categories: any;
  resources: any;
  priorities: any;
  status: any;
  editTasks: FormGroup;


  cancelButtonTasK: any;
  saveButtonTasK: any;
  saveNewButtonTasK: any;
  saveEditButtonTasK: any;
  @ViewChild('newtask', { static: false }) newtask: CreateUpdateTaskComponent;
  settings: any = {};

  //Inputs date
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today = new Date().getTime();
  startDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  dueDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };

  task: any = {
    taskid: '', name: '', projectid: '', employeeid: '', taskresources: '',
    statusid: '',todocategoryid: '',priorityid: '',area: '',phaseid: '',estimatedcost: '',
    startdate: '',estimatedtime: '',duedate: '',completionperc: '',completiondate: '',
    notes: '',sort: '',locationid: '',vendorid: '',SUMMARYTASKID: '',
    resources: '',createon: ''
  }


  //Memorize Task
  popupMemorizedTask: boolean = false;
  dataSummaryMemorizeTask: any = [];
  dataMemorizeTask: any = [];
  acordionClass = '';
  gridClass = '';
  popupNewSummaryMemorize: boolean = false;
  formSummaryMemorize: FormGroup;
  cancelButtonSummaryMemorize: any;
  saveButtonSummaryMemorize: any;

  popupNewTaskMemorize: boolean = false;
  formTaskMemorize: FormGroup;
  cancelButtonMemorizeTasK: any;
  saveButtonMemorizeTasK: any;

  cancelButtonImportMemorizeTasK: any;
  saveButtonImportMemorizeTasK:any;
  disableImport: boolean = true;
  rowSelectedMemorizeTasks: any = [];
  categoriesMemorize: any;

  showpopupDeleteMultipleTask: boolean = false;
  // expandpopup: boolean = false;

  //FullScreen Task Grid
  @ViewChild("originalContainer", { read: ViewContainerRef, static: false }) originalContainer: ViewContainerRef;
  @ViewChild("contenedorPopup", { read: ViewContainerRef, static: false }) contenedorPopup: ViewContainerRef;
  @ViewChild("templateTask", { static: false }) tref: TemplateRef<any>;

  constructor(
    private router: Router,
    private pipeDate: DatePipe,
    private toast: ToastService,
    private taskService: TaskService,
    public generalService: GeneralService,
    private appConfigService: AppConfigService,
  ) {
    console.log('Constructor');
      // botones modal new summary
      this.cancelButtonSummary = {
        text: 'Cancel',
        elementAttr: {
          id: 'bton-gray'
        },
        onClick: () => {
          this.initFormSummaryTask();
          this.popupSummaryTask = false;
        },
      };

      this.saveButtonSummary = {
        text: 'Save',
        icon: 'check',
        elementAttr: {
          id: 'bton-green'
        },
        onClick: () => {
          this.saveUpdateSummary()
        },
      };

    this.dateFormat = appConfigService.dateFormat;
    // this.taskFilters.moduleid = -4;

    this.settings.dateFormat = this.appConfigService.dateFormat;

    DataGrid.defaultOptions({
     device: { deviceType: "phone" },
     options: {
       columnAutoWidth: true,
       columnHidingEnabled: true,
       wordWrapEnabled: false,
       rowAlternationEnabled: false
     }
   });

    DataGrid.defaultOptions({
      device: { deviceType: "desktop" },
      options: {
        columnAutoWidth: true,
        columnHidingEnabled: false
      }
    });

    let filterTaskEditProject = localStorage.getItem('filterTaskEditProject');

    if(filterTaskEditProject!==null && filterTaskEditProject!=='null'){
      this.filterValue = [];
      let filter = JSON.parse(filterTaskEditProject);
      filter.forEach((el,i) => {
        //Filtro de tabla cuando se escribe algo
        if((el=='StartDate' || el=='DUEDATE') && filter[i+1]!=='anyof'){
          filter[i+2] = new Date(filter[i+2]);

        //Filtro de tabla cuando se elige algo desde los checkbox
        }else if((el[0]=='StartDate' || el=='DUEDATE') && el[1]!=='anyof'){
          filter[i][2] = new Date(filter[i][2]);
        }

        this.filterValue.push(el);
      });
    } else {
      this.filterValue = ["STATUSNAME", 'anyof', ['NS','IP']];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.project != undefined){
      if (changes.project.previousValue !== undefined) {
        this._project = changes.project.currentValue;
        this.parentProjectId = changes.project.currentValue.projectid;
        console.log("aqui")
        // this.ngOnInit();
      }
    }
  }

  initView(){
    // setTimeout(() => {
    //   let view = this.tref.createEmbeddedView(null);
    //   this.originalContainer.insert(view);
    //   this.expandpopup = false; 
    // }, 600);
  }

  popupExpand(e){
    this.expandpopup = e;
    this.onOpenFullScreen.emit(e)
  }

  ngOnInit() {
    console.log('Voy Ng On Init')
    this.filterPagedTask.projectid = this.parentProjectId;
    // this.getTask();
    this.getTaksGrid();
    this.initView();
    this.cancelButtonTasK = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.newtask.rebootForm();
        this.popupTask = false;
      },
    };

    this.saveButtonTasK = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newtask.updateTask(false);
      },
    };

    this.saveNewButtonTasK = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(true)
      },

    };

    this.saveEditButtonTasK = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(false, true)
      },

    };

    this.cancelButtonImportMemorizeTasK = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupImportMemorizedTask = false;
      },
    };

    this.saveButtonImportMemorizeTasK = {
      text: 'Import',
      icon: 'check',
      elementAttr: {
        class: 'btn-green1 btn-icon-white',
      },
      onClick: () => {
        this.importMemorize();
      },
    };
    this.inputsDate(this.startDate);
    this.inputsDate(this.dueDate);
  }

  inputsDate(date) {
    date.todayButton = {
      text: "Today",
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate += this.millisecondsInDay;
      }
    };
  }

  getTaksGrid() {
    console.log('Get Task Gridd ');
    this.taskService.GetTasksByProjectId(this.parentProjectId).subscribe(result => {
      let infoFinal = result.map(x=>{
        let durat =  ['', ''];
        if(x.duration){
          let stringDuration = x.duration.toString();
          stringDuration.length>5 ? x.duration = stringDuration.substr(0,3)+':'+stringDuration.substr(4,2) : '';
          durat = x.duration ? stringDuration.split('.') : ['', ''];
        }
        if(durat[1]!==undefined && durat[1]!==null){
          durat[0] = durat[0].substr(0, 3);
          durat[1] = durat[1].substr(0, 2);
          durat[1].length==1 ? durat[1] = durat[1]+'0' : '';
          x.duration = durat[0] + ':'+durat[1];
        }else{
          x.duration.toString().length == 2 || x.duration.toString().length == 3 ? x.duration = x.duration+':00' : '';
          x.duration.toString().length == 1 ? x.duration = '0'+x.duration+':00' : '';
        }

        x.duration == ':' ? x.duration = '00:00': '';
        x.COMPLETIONPERC = x.COMPLETIONPERC * 100
        x.COMPLETIONPERC = parseInt(x.COMPLETIONPERC)
        return x;
      });
      this.taskDataSource = infoFinal
      console.log('Data Task ', result);
    })
  }

  editTask(data) {
    localStorage.setItem('filterTaskEditProject', JSON.stringify(this.filterValue));
    this.router.navigate(['taskManagement/editTask'], { queryParams: { numTODOID: data, projectId: this.parentProjectId, tab: 'Task' } });
  }

  
  GetFilters(data){
    if (data.component.option("filterValue")){
      localStorage.setItem('filterTaskEditProject', JSON.stringify(data.component.option("filterValue")));
    } else {
      localStorage.setItem('filterTaskEditProject', JSON.stringify(data.component.option("filterValue")));
      this.filterValue = []
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'buttonsTask'
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }


  receiveMessage($event) {
  }

  // range slider
  format(value) {
    return value + "%";
  }

  onTooltipShown(val){
    console.log(val);
  }

  initFormSummaryTask() {
    this._formSummary = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      projectid: new FormControl({ value: this.parentProjectId, disabled: false }, [Validators.required]),
      startdate: new FormControl({ value: null, disabled: false }, []),
      duedate: new FormControl({ value: null, disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
    })
  }

  setFormSummaryTask(item) {
    this._formSummary = new FormGroup({
      id: new FormControl({ value: item.ID, disabled: false }, []),
      name: new FormControl({ value: item.NAME, disabled: false }, [Validators.required]),
      projectid: new FormControl({ value: this.parentProjectId, disabled: false }, [Validators.required]),
      startdate: new FormControl({ value: item.STARTDATE, disabled: false }, []),
      duedate: new FormControl({ value: item.DUEDATE, disabled: false }, []),
      completionperc: new FormControl({ value: item.COMPLETIONPERC, disabled: false }, []),
      notes: new FormControl({ value: item.NOTES, disabled: false }, []),
    });

    this.popupSummaryTask = true;
  }

  limpiarmodalTask() {
    $('#btnlimpiarmodaltask').click();
  }

  saveUpdateSummary() {
    let value = this._formSummary.value;

    if (!value.name) {
      this.toast.warning('Please enter summary name');
      return;
    }

    value.projectid = this.parentProjectId;
    value.startdate = value.startdate ? this.pipeDate.transform(value.startdate, 'yyyyMMdd HH:mm:ss') : this.pipeDate.transform(new Date(), 'yyyyMMdd HH:mm:ss');
    value.duedate = value.duedate ? this.pipeDate.transform(value.duedate, 'yyyyMMdd HH:mm:ss') : this.pipeDate.transform(new Date(), 'yyyyMMdd HH:mm:ss');
    value.completionperc = value.completionperc / 100;
    console.log(value);
    this.taskService.UpdateSummaryTask(value).subscribe(result => {
      if (result[0].ResultID > 0) {

        this.toast.success('The Summary Task Information has been Successfully Updated');
        this.popupSummaryTask = false;
        this.getSummaryTask(true);
        // this.getTask();
      }
    });
  }

  onSubmitTask(visibleModal) {
    this.popupTask = visibleModal;
    // this.setGrid2();
    this.getTaksGrid()
  }

  getTask() {
    $("#btntask").click();
  }

  deleteSummary() {
    this.taskService.DeleteSummaryTask(this.summaryToDeleteId).subscribe(result => {
      if (result.length > 0) {
        this.toast.success('The Summary Task Information has been deleted successfully');
        this.getSummaryTask(true);
        // this.getTask();
        this.popupDeleteSummaryTask = false;
      }
    })
  }

  onItemClick(ev) {
    if (ev.itemData.id == 1) {
      this.popupSummaryTask = true;
    }
    else if (ev.itemData.id == 2) {
      this.popupTask = true;
    } else if (ev.itemData.id==3){
      this.popupImportMemorizedTask = true;
      this.getMemorizeTasks();
    }
  }

  openNewTask() {
    this.popupTask = true;
  }

  test(test) {
  }

  getSummaryTask(reload?) {
    if(this.summaryTask.length==0 || reload){
      this.taskService.GetSummaryTask(this.parentProjectId).subscribe(result => {
        console.log('Summay Task', result)
        this.summaryTask = result;
      });
    }
  }

  updateProjectInfo(item) {
    if (item.selectedItem.ID) {
      this._formNewTask.get('projectid').setValue(item.selectedItem.ID);
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }
  //SP_API_Flex_Get_EstimatesSystemProgramDetailAll
  //SP_API_Flex_Get_AreaSystemAll
  //SP_API_Flex_Get_Task_AllByProjectId

  openSWOEdit(swoid) {
    this.router.navigateByUrl('/editSWO');
  }

  clearFilter() {

    this.filterPagedTask = {
      pageindex: 1,
      pagesize: 20,
      orderid: 1,
      summarytaskid: 0,
      projectnumber: '',
      taskname: '',
      responsiblesids: '',
      statusids: '',
      categoryids: '',
      duedate: '',
      taskid: 0,
      projectname: '',
      resourceids: '',
      priorityids: '',
      phaseids: '',
      projectid: this.parentProjectId
    };

    this.taskresourcesText = '';

    this.resourcesText = '';

    this.taskstatusText = '';

    this.categoriesText = '';

    this.get(true);
  }

  syncTreeViewSelection(e) {
    var component = (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (component._userOptions.noDataText == 'No resources to display') {
      if (!this.resourcesText) {
        component.unselectAll();
      }
    }

    if (component._userOptions.noDataText == 'No categories to display') {
      if (!this.categoriesText) {
        component.unselectAll();
      }
    }

    if (component._userOptions.noDataText == 'No responsible to display') {
      if (!this.responsibleText) {
        component.unselectAll();
        // this.taskresponsiblesValues = '';
      }
    }

    if (component._userOptions.noDataText == 'No status to display') {
      if (!this.taskstatusText) {
        component.unselectAll();
      }
    }


  }

  treeView_itemSelectionChanged(e) {
    var nodes = e.component.getNodes();
    var nodesSelectedValue = '';
    var nodesSelectedText = '';
    nodes.forEach(function eachNode(node) {
      if (node.selected == true) {
        nodesSelectedText = nodesSelectedText + node.text + ',';
        nodesSelectedValue = nodesSelectedValue + node.key + ',';
      }
    })

    if (e.component._userOptions.noDataText == 'No resources to display') {
      this.resourcesText = nodesSelectedText;
    }
    if (e.component._userOptions.noDataText == 'No categories to display ') {
      this.categoriesText = nodesSelectedText;
    }
    if (e.component._userOptions.noDataText == 'No status to display') {
      this.taskstatusText = nodesSelectedText;
    }

    if (e.component._userOptions.noDataText == 'No responsible to display') {
      this.responsibleText = nodesSelectedText;
      // this.taskresponsiblesValues = nodesSelectedValue;
      this._formEntity.get('resources').setValue(nodesSelectedValue);
    }

  }

  setGrid2() {
    let mythis = this;
    this.dsPagedTask = AspNetData.createStore({
      key: "ID",
      loadUrl: this.taskService.GetPagedTasksUrl(),
      onBeforeSend: function (e, ajaxOptions) {
        // console.log(e)
        // console.log(ajaxOptions)
        ajaxOptions.method = 'POST';
        mythis.filterPagedTask.pageindex = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
        if (!Number.isInteger(mythis.filterPagedTask.pageindex)) {
          mythis.filterPagedTask.pageindex = 1;
        }
        ajaxOptions.data = JSON.stringify(mythis.filterPagedTask);
        ajaxOptions.contentType = 'application/json';
        ajaxOptions.headers = {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      },
      onUpdated: function (key, values) {
        console.clear();
        // console.log('on key', key);
        // console.log('on values', values);
      },
      onLoading: function (loadoptions) {
        // console.log('on onLoading', loadoptions);

      },
      onLoaded: function (data) {
        // console.log('on loaded', data);
        const grouped = mythis.agruparItems(data);

        return grouped;
        // data = grouped;
        // console.log('datasource', mythis.dsPagedTask);
        // mythis.dsPagedTask = grouped;
        // console.log('on loaded2', data);
      }
    });
    this.loading = false;
    // console.log(this.dsPagedTask);
  }

  agruparItems(array = []) {
    let groupItems = [];
    const source = from(array);
    // group by code
    const example = source.pipe(
      groupBy((item: any) => item.SUMMARYTASKNAME),
      // return each item in group as array
      mergeMap(group => group.pipe(toArray()))
    );

    let contador = 0;
    const subscribe = example.subscribe(val => {
      let obj = {
        key: val[0].SUMMARYTASKNAME,
        items: val
      }
      groupItems[contador] = obj;
      contador++;
    });

    return groupItems;
    // console.log('agrupados ', groupItems);
    // this.subTotal = this.bagService.calcularTotal();
  }

  get(isFilter = false) {

    if (this.loading == true) { return 0; }

    if (isFilter == true) {
      this.filterPagedTask.pageindex = 1;

      this.filterPagedTask.responsiblesids = this.taskresponsiblesValues.join(',');
      this.filterPagedTask.statusids = this.taskstatusValues.join(',');
      this.filterPagedTask.categoryids = this.categoriesValues.join(',');
      this.filterPagedTask.resourceids = this.taskresourcesValues.join(',');
      this.filterPagedTask.priorityids = '';

    }


    this.loading = true;
    localStorage.setItem('filterPagedTask', JSON.stringify(this.filterPagedTask));

    console.clear();
    // console.log(JSON.stringify(this.filterPagedTask));
    // this.setGrid2();
    // this.getTask();

  }

  openTaskEdit(taskid) {
    this.router.navigateByUrl(`/taskManagement/editTask/${taskid}/${this.parentProjectId > 0}`);
  }

  openProjectEdit(projectid, projectnumber) {
    this.router.navigateByUrl(`/editSales/${projectnumber}/${projectid}`);
  }

  // Modal Grid Summary Task

  mdSummaryTask() {
    this.initFormSummaryTask();
    this.getSummaryTask(true);
    this.popupGridSummaryTask = true;
  }

  //Modal Edit Multiple Tasks

  mdEditTasks() {
    if(this.categorySelect.length==0){
      this.taskService.GetTaskCategories().subscribe(result => {
        this.categorySelect = result;
      });
    }
    if(this.statusSelect.length==0){
      this.taskService.GetTaskStatus().subscribe(result => {
        this.statusSelect = result;
      });
    }
    if(this.prioritySelect.length==0){
      this.taskService.GetTaskPriorities().subscribe(result => {
        this.prioritySelect = result;
      });
    }
    if(this.employeeSelect==0){
      this.taskService.GetTaskEmployees().subscribe(result => {
        this.employeeSelect = result;
      });
    }
    
    this.getSummaryTask();

    this.popupEditTask = true;
    this.rowSelectedTask = [];
    this.rowSelectedTask = this.TasksGrid.instance.getSelectedRowsData();
    this.setEditForm();
  }

  setEditForm() {
    this.editTasks = new FormGroup({
      responsibleid: new FormControl('', []),
      resourceArray: new FormControl('', []),
      categoryid: new FormControl('', []),
      priorityid: new FormControl('', []),
      statusid: new FormControl('', []),
      completionperc: new FormControl(0, []),
      sort: new FormControl('', []),
      summarytaskid: new FormControl('', []),
    })
  }

  selectionChanged(data) {
    this.rowSelectedTask = this.TasksGrid.instance.getSelectedRowsData();
    // this.selectedRows = true;
    if (this.rowSelectedTask.length >= 1) {
      this.selectedRows = true;
    } else { this.selectedRows = false; }
  }

  updateTasks() {
    let form = this.editTasks.value;

    this.rowSelectedTask.forEach(async (task, i) => {
      console.log('Guardado ', task);
      form.responsibleid == "" ? this.task.employeeid = task.EMPLOYEEID : this.task.employeeid = form.responsibleid;
      if(form.resourceArray == ""){
        this.task.taskresources = task.resourcesIDs
      }else{
        let arr = task.resourcesIDs.split(',');
        arr.push(form.resourceArray);
        this.task.taskresources = arr.join(',');
      }
      task.COMPLETIONPERC = form.completionperc !== 0 ? form.completionperc/100 : task.COMPLETIONPERC/100;

      form.statusid == "" ? this.task.statusid = task.STATUSID : this.task.statusid = form.statusid;
      if (form.statusid == 3) { this.task.completionperc = 1; } else { this.task.completionperc = task.COMPLETIONPERC; }
      form.categoryid == "" ? this.task.todocategoryid = task.TODOCATEGORYID : this.task.todocategoryid = form.categoryid;
      form.priorityid == "" ? this.task.priorityid = task.PRIORITYID : this.task.priorityid = form.priorityid;
      form.summarytaskid !== "" ? this.task.summarytaskid = form.summarytaskid : this.task.summarytaskid = task.summarytaskid;
      this.task.sort =  form.sort !== "" ? form.sort : task.order;

      this.task.area = task.area;
      task.LOCATIONID == null ?   this.task.locationid= 0 : this.task.locationid= task.LOCATIONID;
      task.PHASEID == null ? this.task.phaseid  = 0 : this.task.phaseid = task.PHASEID;
      task.VENDORID == null ?  this.task.vendorid = 0 : this.task.vendorid = task.VENDORID;
      this.task.estimatedcost = task.estimatecost;
      // this.task.sort = task.order;
      this.task.name = task.TASKNAME;
      this.task.notes = task.notes;
      this.task.completiondate = task.COMPDATE ? this.pipeDate.transform(task.COMPDATE, 'yyyyMMdd hh:mm:ss') : '';
      this.task.duedate = task.DUEDATE ? this.pipeDate.transform(task.DUEDATE, 'yyyyMMdd hh:mm:ss'): '';
      this.task.estimatedtime = task.ESTIMATEDTIME;
      this.task.resources = this.task.taskresources;
      this.task.vendorid = task.VENDORID;
      this.task.taskid = task.ID;
      this.task.projectid = task.PROJECTID;
      this.task.startdate = task.StartDate ? this.pipeDate.transform(task.StartDate, 'yyyyMMdd hh:mm:ss'): '';
      this.task.method = 'Insert_Task_ce';
      // console.log('Guardado', this.task);
      this.taskService.updateTask2(this.task).subscribe(result => {
        // console.log('Actualizado', result)
        if (this.rowSelectedTask.length == i + 1) {
          this.toast.success('The Task list has been updated successfully');
          this.popupEditTask = false;
          this.getTaksGrid();
        }
      })
    });

  }

  deleteTask(id) {
    this.taskService.DeleteTask(id).subscribe(result => {
      this.getTaksGrid();
      this.toast.success('The Task Information has been deleted successfully.');
      this.showpopupDeleteTask = false;
    })
  }

  popupDeleteTask(data) {
    this.selectedTaskId = data.ID;
    this.showpopupDeleteTask = true;
  }

  duplicateTask(id) {
    this.taskService.DuplicateTaskGrid(id).subscribe(result => {
      this.toast.success('The Task Information has been duplicated successfully.');
      this.getTaksGrid();
      // this.showpopupDuplicateTask = false;
    })
  }

  popupDuplicateTask(data) {
    this.selectedTaskId = data.ID;
    this.showpopupDuplicateTask = true;
  }

  //Import Memorize Task
  getMemorizeTasks(){
    this.taskService.Get_ProjectTodoMemorized(this.project).subscribe(result=>{
      this.dataMemorizeTask = result;
    })
  }

  formatDuration(DURATION) {
    let durat = DURATION ? DURATION.toString().split('.') : ['', ''];
    durat[0] = durat[0] ? durat[0].substr(0, 2).padStart(2, '0') : '00';
    durat[1] = durat[1] ? durat[1].substr(0, 2).padEnd(2, '0') : '00';

    return durat[0] + ':' + durat[1];
  }

  ImportSelectionChanged(data) {
    this.rowSelectedMemorizeTasks = this.MemorizeTasksGrid.instance.getSelectedRowsData();

    if (this.rowSelectedMemorizeTasks.length >= 1) {
      this.disableImport = false;
    } else { this.disableImport = true; }
  }

  prepareRowPart(info){
    if (info.rowType === "data") {
      if (info.data.MILESTONEID2 == 1) {
        info.rowElement.style.backgroundColor = "#e6c7a7";
      }
    }
  }

  importMemorize(){
    // console.log(this.rowSelectedMemorizeTasks);
    let array = []
    this.rowSelectedMemorizeTasks.forEach((element,i) => {
      array.push(element.ID);
      if(this.rowSelectedMemorizeTasks.length==i+1){
        let ids;
        if(array){ids = array.join(',');}
        // console.log(ids);
        let obj = {method: 'Insert_ProjectMemorizedTaskCEByMemorizedIdsCE', projectid: this.project.projectid, memorizedtaskids: ids};
        console.log(obj);
        this.taskService.GeneralService(obj).subscribe(result=>{
          // console.log('Importado ', result);

          this.toast.success('The Memorized Tasks have been imported successfully');
          this.popupImportMemorizedTask = false;
          this.rowSelectedMemorizeTasks = [];
          this.MemorizeTasksGrid.instance.clearSelection();
          this.getTaksGrid();
        })
      }
    });
  }

  mdGanttView(){
    console.log('Popup abrete');
    // this.router.navigateByUrl(`/ganttScheduler/${this.parentProjectId}`);
    this.router.navigate(['/ganttScheduler'], { queryParams: {projectid: this.parentProjectId}});
  }
  task2: any = {
    taskid: '', name: '', projectid: '', employeeid: '', taskresources: '',
    statusid: '',todocategoryid: '',priorityid: '',area: '',phaseid: '',estimatedcost: '',
    startdate: '',estimatedtime: '',duedate: '',completionperc: '',completiondate: '',
    notes: '',sort: '',locationid: '',vendorid: '',SUMMARYTASKID: '',
    resources: '',createon: '',method:'Insert_Task_ce'
  }

  updatePercent(e){
    console.log(e);
    let task = e.oldData;
    this.task2.employeeid = e.oldData.EMPLOYEEID;
    this.task2.taskresources = task.resourcesIDs;
    this.task2.statusid = task.STATUSID;

    if(e.newData.COMPLETIONPERC != undefined){
      this.task2.completionperc = Number(e.newData.COMPLETIONPERC) / 100;
    } else {
      this.task2.completionperc = Number(e.oldData.COMPLETIONPERC) / 100;
    }

    // *************
    this.task2.todocategoryid = task.TODOCATEGORYID ;
    this.task2.priorityid = task.PRIORITYID;
    this.task2.area = task.area;
    this.task2.locationid= task.LOCATIONID;
    this.task2.phaseid = task.PHASEID;
    this.task2.vendorid = task.VENDORID;
    this.task2.estimatedcost = task.estimatecost;
    this.task2.summarytaskid = task.summarytaskid;

    if(e.newData.order != undefined){
      this.task2.sort = e.newData.order;
    } else {
      this.task2.sort = e.oldData.order;
    }

    this.task2.name = task.TASKNAME;
    this.task2.notes = task.notes;
    this.task2.completiondate = task.COMPDATE;
    // this.task2.duedate = task.DUEDATE;
    this.task2.duedate = task.DUEDATE ? this.pipeDate.transform(task.DUEDATE, 'yyyyMMdd hh:mm:ss'): '';
    this.task2.startdate = task.StartDate ? this.pipeDate.transform(task.StartDate, 'yyyyMMdd hh:mm:ss'): '';
    this.task2.estimatedtime = task.ESTIMATEDTIME;
    this.task2.resources = this.task2.taskresources;
    this.task2.vendorid = task.VENDORID;
    this.task2.taskid = task.ID;
    this.task2.projectid = task.PROJECTID;
    this.task2.method = 'Insert_Task_ce';
    // this.task2.taskid = e.oldData.ID
    console.log(this.task2);
    this.taskService.updateTask2(this.task2).subscribe(result => {
      this.toast.success('The Task list has been updated successfully');
      this.getTaksGrid();
    })
  }

  deleteMultipleTask(){
    console.log(this.rowSelectedTask);
    this.rowSelectedTask.forEach((task, i) => {
      this.taskService.DeleteTask(task.ID).subscribe(result => {
        if(this.rowSelectedTask.length == i+1){
          this.toast.success('The Task Information has been deleted successfully.');
          this.showpopupDeleteMultipleTask = false;
          this.popupEditTask = false;
          this.getTaksGrid();
          this.rowSelectedTask = [];
        }
      })
    })
  }

  
}
